import { useContext } from 'react';
import JobContext, { IJobContext } from './Context';

const useJobContext = (): IJobContext => useContext(JobContext);

export default useJobContext;